import useAuth from '@byma/shared/hooks/useAuth'
import FormSection from '@byma/shared/components/FormSection'
import MoneyInput from '@byma/shared/components/MoneyInput'
import EventSelector from 'components/EventSelector'
import { useRouter } from 'next/router'
import useToastContext from "@byma/shared/hooks/useToastContext";
import useSWR, { useSWRConfig } from 'swr'
import dayjs from 'dayjs'
import fetcher from '@byma/shared/helpers/fetcher'
import Loader from '@byma/shared/components/Loader'
import Input from '@byma/shared/components/Input'
import { useState, useRef } from 'react'
import useFilters from '@byma/shared/hooks/useFilters'
import { isValidCPF, isValidCNPJ, isValidEmail, isValidPhone, isValidRandomPixKey } from '@byma/shared/helpers/validators'

export default function NewWithdrawal({ disabled, availableCents, eventIds }) {
    const session = useAuth()
    const { token, user: currentUser } = session
    const [newWithdrawalOpen, setNewWithdrawalOpen] = useState(false);
    const [successModalOpen, setSuccessModalOpen] = useState(false);
    const [signer, setSigner] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const addToast = useToastContext()
    const formRef = useRef()
    const { query, ...router } = useRouter()
    const { mutate } = useSWRConfig()
    const { queryString } = useFilters({...query, d:'all'})
    const [selectedEvent, setSelectedEvent] = useState(null)
    //const { data: parties, error } = useSWR(token ? [`/api/parties/getAll?search=${searchQuery}&perPage=20`, null, token] : null, fetcher)
    //

    async function handleSave(e) {
        e.preventDefault()

        if (!selectedEvent) {
            return addToast('Selecione um evento primeiro', 'error')
        }

        setIsLoading(true)
        const body = {
            partyId: selectedEvent._id,
            description: e.currentTarget.description.value,
            amountCents: Math.round(parseFloat(e.currentTarget.amountCents.value.replace(/\./g, '').replace(/,/, '.')) * 100),
            pixKey: e.currentTarget.pixKey.value,
            pixKeyType: e.currentTarget.pixKeyType.value,
            pixKeyHolderName: e.currentTarget.pixKeyHolderName.value,

        }

        if (body.pixKeyType === 'CPF' && !isValidCPF(body.pixKey)) {
            setIsLoading(false)
            return addToast('CPF inválido', 'error')
        }

        if (body.pixKeyType === 'CNPJ' && !isValidCNPJ(body.pixKey)) {
            setIsLoading(false)
            return addToast('CNPJ inválido', 'error')
        }

        if (body.pixKeyType === 'EMAIL' && !isValidEmail(body.pixKey)) {
            setIsLoading(false)
            return addToast('Email inválido', 'error')
        }

        if (body.pixKeyType === 'PHONE' && !isValidPhone(body.pixKey)) {
            setIsLoading(false)
            return addToast('Telefone inválido', 'error')
        }

        if (body.pixKeyType === 'RANDOM' && !isValidRandomPixKey(body.pixKey)) {
            setIsLoading(false)
            return addToast('Chave PIX inválida', 'error')
        }

        if (body.amountCents > availableCents) {
            setIsLoading(false)
            return addToast('Saldo insuficiente', 'error')
        }

        try {
            const res = await fetch('/api/withdrawals/create', {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'Auth': token
                },
                body: JSON.stringify(body),
            })
            if (res.status === 200) {
                const result = await res.json()
                setNewWithdrawalOpen(false)
                formRef.current.reset()
                setSigner(result.signer)
                setSuccessModalOpen(true)
                addToast('Saque cadastrado com sucesso')
                mutate([`/api/payments/report?${queryString}`, null, token])
                mutate([`/api/invoiceitems/getAll?${queryString}`, null, token])
                mutate([`/api/receivables/getAll?${queryString}`, null, token])
                mutate([`/api/anticipations/getAll?${queryString}`, null, token])
                mutate([`/api/withdrawals/getAll?${queryString}`, null, token])
                mutate([`/api/withdrawals/getAll?status=requested&limit=30`, null, token])
                setIsLoading(false)
            } else {
                throw new Error(await res.json())
            }
        } catch (error) {
            setIsLoading(false)
            addToast('Erro ao cadastrar saque', 'error')
            console.error('An unexpected error happened occurred:', error)
        }
    }

    return (
        <div className="">
            <button className={`flex justify-between items-center space-x-1 rounded shadow px-2 py-1 text-sm whitespace-nowrap focus:shadow-sm ${disabled ? 'bg-gray-300 cursor-default' : 'hover:shadow-md cursor-pointer bg-white'}`} onClick={() => !disabled && setNewWithdrawalOpen(!newWithdrawalOpen)}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
                </svg>
                <p>Novo saque</p>
            </button>
            <div className={`fixed w-full h-full inset-0 transition-opacity duration-100 ${newWithdrawalOpen ? 'z-50 opacity-100' : '-z-1 opacity-0'}`} onClick={() => setNewWithdrawalOpen(false)}>
                <div class="absolute w-full h-full bg-gray-900 opacity-50" />
                <div class="modal-content absolute bg-white w-full md:w-11/12 md:max-w-screen-md md:mx-auto md:rounded md:shadow-lg z-50 h-full overflow-y-auto p-3" onClick={(e) => e.stopPropagation()}>
                    <div className="">
                        <div className="flex justify-between items-center mb-3">
                            <div className="">
                                <p className="font-bold text-xl">Novo saque</p>
                            </div>
                            <div className="cursor-pointer" onClick={() => setNewWithdrawalOpen(false)}>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                </svg>
                            </div>
                        </div>
                        <EventSelector 
                            selectedEvent={selectedEvent} 
                            onChange={setSelectedEvent} 
                            eventIds={eventIds}
                        />
                        <form onSubmit={handleSave} className="flex flex-col space-y-3" ref={formRef}>
                            <FormSection
                                title="Valor do saque"
                                infos={
                                    <div className="flex flex-col space-y-3">
                                        <p className="text-gray-800">
                                            Insira o valor que deseja sacar, em reais, respeitando as condições contratuais e o saldo disponível para saque.
                                        </p>
                                    </div>
                                }
                            >
                                <div className="flex space-x-3">
                                    <MoneyInput name="amountCents" label="Valor" step="0.01" required size="s" />
                                </div>
                            </FormSection>
                            <FormSection
                                title="Destino do pagamento"
                                infos={
                                    <div className="flex flex-col space-y-3">
                                        <p className="text-gray-800">
                                            Preencha com as informações da chave PIX que receberá o pagamento.
                                        </p>
                                    </div>
                                }
                            >
                                <div className="flex flex-col space-y-3">
                                    <div className="col-span-2">
                                        <Input 
                                            size="s"
                                            type="text" 
                                            label='Chave PIX' 
                                            required
                                            name="pixKey"
                                        />
                                    </div>
                                    <div className="w-full">
                                        <select
                                            placeholder="Tipo de chave"
                                            className={`p-2 h-min w-full`}
                                            name="pixKeyType"
                                            required
                                        >
                                            <option value="">Tipo de chave</option>
                                            <option value="CPF">CPF</option>
                                            <option value="CNPJ">CNPJ</option>
                                            <option value="EMAIL">Email</option>
                                            <option value="PHONE">Telefone</option>
                                            <option value="RANDOM">Aleatória</option>
                                        </select>
                                    </div>
                                    <div className="col-span-3">
                                        <Input 
                                            size="s"
                                            type="text" 
                                            label='Titular da Chave PIX' 
                                            name="pixKeyHolderName"
                                            required
                                        />
                                    </div>
                                </div>
                            </FormSection>
                            <FormSection
                                title="Observações"
                                infos={
                                    <div className="flex flex-col space-y-3">
                                        <p className="text-gray-800">
                                            Escolha uma descrição que caracterize o saque.
                                        </p>
                                        <p className="text-gray-800">
                                            Por exemplo: Artista X (parcela 1). O campo de observações te
                                            ajudará a ter melhor controle e identificação dos seus pedidos de saque.
                                        </p>
                                    </div>
                                }
                            >
                                <Input name="description" type="text" label="Observações" required size="s" />
                            </FormSection>
                            <div className="">
                                {isLoading ? <Loader /> : (
                                    <button type="submit" className="btn btn-primary w-full">Solicitar saque</button>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={`fixed w-full h-full inset-0 transition-opacity duration-100 ${successModalOpen ? 'z-50 opacity-100' : '-z-1 opacity-0'}`} onClick={() => setSuccessModalOpen(false)}>
                <div class="absolute w-full h-full bg-gray-900 opacity-50" />
                <div class="modal-content absolute bg-white w-full md:w-11/12 md:max-w-screen-md md:mx-auto md:rounded md:shadow-lg z-50 md:h-min overflow-y-auto p-3" onClick={(e) => e.stopPropagation()}>
                    <div className="">
                        <div className="flex justify-between items-center mb-3">
                            <div className="">
                                <p className="font-bold text-xl">Solicitação criada com sucesso!</p>
                            </div>
                            <div className="cursor-pointer" onClick={() => setSuccessModalOpen(false)}>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                </svg>
                            </div>
                        </div>
                        <div className="flex flex-col space-y-3">
                            <p className="text-gray-800">
                                Sua solicitação de saque foi criada com sucesso!
                            </p>
                            <p className="text-gray-800">
                                Para confirmar a solicitação, acesse o link enviado via email e WhatsApp para o signatário do contrato.
                            </p>
                        </div>

                        <div className="flex flex-col space-y-1 bg-gray-50 border p-3 mt-3">
                            <p className="text-gray-800 font-bold">Dados do signatário</p>
                            <p className="text-gray-800">
                                <strong>Nome:</strong> {signer?.profile?.name}
                            </p>
                            <p className="text-gray-800">
                                <strong>E-mail:</strong> {signer?.email}
                            </p>
                            {signer?.profile?.phone && (
                                <p className="text-gray-800">
                                    <strong>Telefone:</strong> {signer?.profile?.phone}
                                </p>
                            )}
                        </div>

                        <button className="btn btn-primary mt-6" onClick={() => setSuccessModalOpen(false)}>Fechar janela</button>
                    </div>
                </div>
            </div>
        </div>
    )

}
